import React from 'react';
import styled from 'styled-components';
import { RowDiv, Span, Text } from 'components/intro/Custom';
import { Icon } from './Icon';

function Footer(props) {
  return (
    <FooterWrap>
      <Icon name="logoWhite" $sHeight={20} />
      <RowDiv $gap={14} $tGap={6} $alingItems="center" $tFlexDirection="column">
        <Text $fontWeight={500} $sFontSize={10}>
          대전광역시 유성구 테크노9로 35 IT벤처타운 407호 (우 : 34027)
        </Text>
        <Span $tDisplay="none">|</Span>
        <RowDiv $alingItems="center" $gap={14} $sGap={2} $sFlexDirection="column">
          <Text $fontWeight={500} $sFontSize={10}>
            Tel : 042-933-9060
          </Text>
          <Span $fontWeight={500} $sFontSize={10} $sDisplay="none">
            |
          </Span>
          <Text $fontWeight={500} $sFontSize={10}>
            Fax : 0508-958-1530
          </Text>
          <Span $fontWeight={500} $sFontSize={10} $sDisplay="none">
            |
          </Span>
          <Text $fontWeight={500} $sFontSize={10}>
            E-mail : farmin0130@farm-in.kr
          </Text>
        </RowDiv>
      </RowDiv>
    </FooterWrap>
  );
}

const FooterWrap = styled.footer`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.lightGray};
  padding: 40px 0;
  gap: 30px;
  min-height: 140px;

  @media ${({ theme }) => theme.device.tabelt} {
    gap: 10px;
    flex-direction: column;
    padding: 40px;
    align-items: flex-start;
  }
  @media ${({ theme }) => theme.device.mobile} {
    padding: 20px;
    ${({ $mFontSize }) => $mFontSize && `font-size: ${$mFontSize}px`};
  }
`;

export default Footer;
